import { type FormHTMLAttributes, forwardRef, type ReactNode } from 'react';

import { Stack } from '../../atoms/Stack';

type Props = Omit<FormHTMLAttributes<HTMLFormElement>, 'style' | 'className' | 'children'> & {
  children: ReactNode;
};

// forwardRef, not a `ref` prop: the app still runs React 18, where function components never receive `ref`.
export const FormContainer = forwardRef<HTMLFormElement, Props>(function FormContainer(props, ref) {
  const { children, ...formProps } = props;

  return (
    <form {...formProps} ref={ref}>
      <Stack spacing={3}>{children}</Stack>
    </form>
  );
});

export type { Props as FormContainerProps };
